import { render, staticRenderFns } from "./PayCardGoods.vue?vue&type=template&id=5b44f5fc&scoped=true&"
import script from "./PayCardGoods.vue?vue&type=script&lang=js&"
export * from "./PayCardGoods.vue?vue&type=script&lang=js&"
import style0 from "./PayCardGoods.vue?vue&type=style&index=0&id=5b44f5fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b44f5fc",
  null
  
)

export default component.exports